function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Adapted from https://github.com/reach/router/blob/b60e6dd781d5d3a4bdaaf4de665649c0f6a7e78d/src/lib/history.js
 *
 * https://github.com/reach/router/blob/master/LICENSE
 * */
function getLocation(source) {
  return _objectSpread({}, source.location, {
    state: source.history.state,
    key: source.history.state && source.history.state.key || "initial"
  });
}

function createHistory(source, options) {
  var listeners = [];
  var location = getLocation(source);
  return {
    get location() {
      return location;
    },

    listen: function listen(listener) {
      listeners.push(listener);

      var popstateListener = function popstateListener() {
        location = getLocation(source);
        listener({
          location: location,
          action: "POP"
        });
      };

      source.addEventListener("popstate", popstateListener);
      return function () {
        source.removeEventListener("popstate", popstateListener);
        var index = listeners.indexOf(listener);
        listeners.splice(index, 1);
      };
    },
    navigate: function navigate(to) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          state = _ref.state,
          _ref$replace = _ref.replace,
          replace = _ref$replace === void 0 ? false : _ref$replace;

      state = _objectSpread({}, state, {
        key: Date.now() + ""
      }); // try...catch iOS Safari limits to 100 pushState calls

      try {
        if (replace) {
          source.history.replaceState(state, null, to);
        } else {
          source.history.pushState(state, null, to);
        }
      } catch (e) {
        source.location[replace ? "replace" : "assign"](to);
      }

      location = getLocation(source);
      listeners.forEach(function (listener) {
        return listener({
          location: location,
          action: "PUSH"
        });
      });
    }
  };
} // Stores history entries in memory for testing or other platforms like Native


function createMemorySource() {
  var initialPathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var index = 0;
  var stack = [{
    pathname: initialPathname,
    search: ""
  }];
  var states = [];
  return {
    get location() {
      return stack[index];
    },

    addEventListener: function addEventListener(name, fn) {},
    removeEventListener: function removeEventListener(name, fn) {},
    history: {
      get entries() {
        return stack;
      },

      get index() {
        return index;
      },

      get state() {
        return states[index];
      },

      pushState: function pushState(state, _, uri) {
        var _uri$split = uri.split("?"),
            _uri$split2 = _slicedToArray(_uri$split, 2),
            pathname = _uri$split2[0],
            _uri$split2$ = _uri$split2[1],
            search = _uri$split2$ === void 0 ? "" : _uri$split2$;

        index++;
        stack.push({
          pathname: pathname,
          search: search
        });
        states.push(state);
      },
      replaceState: function replaceState(state, _, uri) {
        var _uri$split3 = uri.split("?"),
            _uri$split4 = _slicedToArray(_uri$split3, 2),
            pathname = _uri$split4[0],
            _uri$split4$ = _uri$split4[1],
            search = _uri$split4$ === void 0 ? "" : _uri$split4$;

        stack[index] = {
          pathname: pathname,
          search: search
        };
        states[index] = state;
      }
    }
  };
} // Global history uses window.history as the source if available,
// otherwise a memory history


var canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var globalHistory = createHistory(canUseDOM ? window : createMemorySource());
var navigate = globalHistory.navigate;
export { globalHistory, navigate, createHistory, createMemorySource };